import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">We are committed to protecting your privacy. This policy outlines how we handle your data when using our Jobber integration App.</p>

      <ol className="list-decimal ml-6 space-y-4">
        <li>
          <strong>Data Collection:</strong> We collect only what is necessary to interact with the Jobber API: client data, lead notes, and authorization tokens.
        </li>
        <li>
          <strong>Data Storage:</strong> All stored data is encrypted and managed securely. We do not store any Jobber credentials.
        </li>
        <li>
          <strong>Third Parties:</strong> We do not sell or share your data with third parties. All integrations are limited to Jobber.
        </li>
        <li>
          <strong>User Rights:</strong> You may disconnect the app at any time via your Jobber account or by contacting our support team.
        </li>
        <li>
          <strong>Changes:</strong> Any changes to this policy will be posted on this page.
        </li>
      </ol>

      <p className="mt-6 text-sm text-gray-500">Effective Date: May 2025<br/>Contact: <a href="mailto:hi@lsarespond.com" className="text-blue-600 underline">hi@lsarespond.com</a></p>
    </div>
  );
};

export default PrivacyPolicy;